import React from "react";
import type { GetStaticPropsContext, NextPage } from "next";
import { useRouter } from "next/router";

import JoinRemax from "@components-pages/unete/JoinRemax";
import Statistic from "@components-pages/unete/Statistic";
import Motivation from "@components-pages/unete/Motivation";
import HeadMeta, { IHeadMetaComponent } from "@components/head-meta";
import { CKeyWordsPages } from "shared/models/const/keywords.const";
import WsPhantomNav from "@components/a1-refactor/typography/WsPhantomNav";

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      messages: (await import(`@lang/${locale}.json`)).default,
    },
  };
}

const Unete: NextPage = () => {
  const router = useRouter();

  const metaData: IHeadMetaComponent = {
    description: "join",
    keyWords: CKeyWordsPages.join,
    title: "join",
    url: router.asPath,
    picture:
      "/images/image-optimize/happy-couple-with-keys-of-new-apartment.webp",
  };

  return (
    <>
      <HeadMeta {...metaData} />
      <WsPhantomNav />
      <JoinRemax />
      <Statistic />
      <Motivation />
    </>
  );
};

export default Unete;
